import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { listProperties, removeCaracter } from '../../../core/constants/properties-const';
import { PropertiesService } from 'src/app/properties/service/properties.service';


@Component({
  selector: 'app-product-registration',
  templateUrl: './product-registration.component.html',
  styleUrls: ['./product-registration.component.scss']
})
export class ProductRegistrationComponent implements OnInit {

  title = 'Cadastro de produto';
  @Output() closeNewProduct: EventEmitter<any> = new EventEmitter<any>();
  public showMap = false;
  public search = false;
  public showForm = false;
  public closeDropDown = false;
  public returnForm = false;
  private docBody = document.querySelector('body');

  public listImoveis = listProperties;
  public dataValue = null;
  public titleList: string;
  public code: number;
  public form: FormGroup;
  public removeCaracter = removeCaracter;
  public openForm = false;

  private listValidator = [
    'typeCode',
    'zip_code',
    'street',
    'number',
    'neighborhood',
    'value_zone',
    'location_value_zones',
    'geographic_area'
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private service: PropertiesService
  ) { }

  ngOnInit(): void {
    this.addressForm();
    this.docBody.setAttribute('style', 'overflow: hidden');
    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  closeModal() {
    this.closeNewProduct.emit(false);
    this.docBody.setAttribute('style', 'overflow: auto');
  }

  toggleMap(event) {
    this.showMap = event;
  }

  // 88050150
  private addressForm(): void {
    this.form = this.formBuilder.group({
      id: [null],
      typeCode: [null],
      zip_code: ['06363589'],
      street: ['Avenida Professor Luiz Ignácio Anhaia Mello'],
      country: ['Brasil'],
      number: ['627'],
      complement: [null],
      neighborhood: ['Jardim América'],
      state: ['SP'],
      city: ['Vila Bela da Santíssima Trindade'],
      value_zone: [null],
      location_value_zones: [null],
      geographic_area: [null],
      condominium: ['Penha Plano Manoel Leiroz de Azevedo'],
      area_util: [null],
      areat_total: [null],
      single_tower: [false],
      number_name_tower: [null],
      floor: [null],
      unity: [null],
      not_number: [false]
    });
    this.form.get('city').disable();
    this.form.get('state').disable();
  }

  public setValue(): void {
    if (this.form.get('zip_code').value.length === 8) {
      this.service.getZipCode(this.form.get('zip_code').value)
        .subscribe(x => {
          this.form.patchValue(x);
          this.validRequest(x);
        });
    }
  }

  private validRequest(x) {
    if (!x.geographic_area.name || !x.value_zone.name || !x.location_value_zones) {
      this.form.patchValue({ geographic_area: x.geographic_area.name });
      this.form.patchValue({ value_zone: x.value_zone.name });
      this.form.patchValue({ location_value_zones: x.location_value_zones.name });
    }
  }

  public sendingDataForm(): void {
    Object.keys(this.form.controls).forEach((x: string) => {
      if (this.form.get(x).value === '' || this.form.get(x).value === null) {
        this.validFormNotRequired(x);
        this.verificationFieldValid(x);
      }
      this.validatorZipCode(x);
    });
    if (this.form.valid) {
      this.redirectNewRegistry();
      this.service.sendingForm(this.form.value);
      localStorage.setItem('form', JSON.stringify(this.form.value));
    }
  }

  private verificationFieldValid(x: string) {
    const listType = [3, 4, 7, 8, 17, 19, 26, 29, 38];
    if (listType[this.form.get('typeCode').value]) {
      this.applicationValidatorField(this.listValidator, x);
    } else {
      this.applicationValidatorField(['typeCode', 'zip_code', 'street', 'number', 'neighborhood'], x);
    }
  }

  private applicationValidatorField(list: string [], compared: string) {
    if (list.length) {
      list.forEach(x => {
        if (compared === x) {
          this.form.get(x).setErrors({ required: false });
        }
      });
    }
  }

  public redirectNewRegistry(): void  {
    this.router.navigate(['registro'], { relativeTo: this.route });
  }

  private validFormNotRequired(x: string): void {
    if (x === 'state' || x === 'city') {
      this.form.get(x).setErrors({ required: false });
    }
  }

  public assigningValue(data: any): void {
    this.titleList = data.item;
    this.closeDropDown = false;
    this.code = data.code;
    this.form.get('typeCode').setValue(data.code);
  }

  public not_number() {
    if (this.form.get('not_number').value === true) {
      this.enabledFieldControl('number');
    } else {
      this.disabledFieldControl('number');
    }
  }

  public disabledDescription(): void {
    if (this.form.get('single_tower').value) {
      this.listErrors(['number_name_tower', 'floor', 'unity'], false);
    } else {
      this.listErrors(['number_name_tower', 'floor', 'unity'], true);
    }
  }

  public disabledFieldControl(data: string): void {
    this.form.get(data).disable();
    this.form.get(data).setErrors({ required: false });
  }

  public enabledFieldControl(data: string): void {
    this.form.get(data).enable();
    this.form.get(data).setErrors({ required: true });
  }

  public listErrors(listErrors: string[], required: boolean): void {
    listErrors.forEach(field => this.form.get(field).setErrors({ required }));
  }

  public openMaps() {
    this.showMap = !this.showMap;
    if (this.showMap) {
      this.returnForm = true;
    } else {
      this.returnForm = false;
    }
  }

  public openFormModal() {
    this.showMap = false;
    this.showForm = !this.showForm;
  }

  public validatorZipCode(x: string) {
    if (x === 'zip_code') {
      if (this.form.get(x).value === null) {
        this.form.get(x).setErrors({ required: true });
      }
      if (this.form.get(x).value && this.form.get(x).value.toString().length < 8) {
        this.form.get(x).setErrors({ invalidNumber: true });
      }
    }
  }

  public closeModalForm(event: boolean) {
    this.openForm = event;
  }

}
